/* Page de resultats (section k-search-funnel-v2) : script principal, sorti du gabarit le
   02/11 (lot 4 C, perf) pour etre mis en cache au lieu d'etre recharge dans chaque page
   (100 Ko par affichage). Charge en defer apres k-search-core.js (ordre du document). */
(() => {
    const root = document.querySelector('.kFunnel');
    if (!root) return;
    root.setAttribute('data-enhanced', 'true');

    const params = new URLSearchParams(window.location.search);
    const previewThemeId = params.get('preview_theme_id');
    const finderAssetUrl = document.querySelector('script[data-k-search-core]')?.dataset?.finderUrl || '';

    const resolveFinderImageSrc = (image) => {
      const src = String(image?.src || '').trim();
      if (!src) return '';
      if (/^(?:https?:)?\/\//.test(src) || src.startsWith('/')) return src;
      try {
        const base = finderAssetUrl
          ? new URL(finderAssetUrl, window.location.href)
          : new URL(window.location.href);
        return new URL(src, base).href;
      } catch (_error) {
        return src;
      }
    };

    const resolveFinderAssetSrc = (filename) => {
      const src = String(filename || '').trim();
      if (!src) return '';
      if (/^(?:https?:)?\/\//.test(src) || src.startsWith('/')) return src;
      try {
        const base = finderAssetUrl
          ? new URL(finderAssetUrl, window.location.href)
          : new URL(window.location.href);
        return new URL(src, base).href;
      } catch (_error) {
        return src;
      }
    };

    // Recadrage par le CDN (02/11, lot 4 A) : meme carre que hydrateSchemaCrops (environ 16 % du petit
    // cote, entre 300 et 520 px de la planche), calcule avec les dimensions de la planche (finder-data).
    // Sans dimensions : null, et la carte garde le recadrage par le script.
    const schemaCdn = (src, dims, highlight) => {
      const nw = Number(dims && dims[0]) || 0;
      const nh = Number(dims && dims[1]) || 0;
      const x = Number(highlight && highlight.x_pct);
      const y = Number(highlight && highlight.y_pct);
      if (!nw || !nh || !Number.isFinite(x) || !Number.isFinite(y) || !/\/(files|assets)\//.test(src)) return null;
      const petit = Math.min(nw, nh);
      const cote = Math.min(petit, Math.max(300, Math.min(520, Math.round(petit * 0.16))));
      const px = (Math.max(0, Math.min(100, x)) / 100) * nw;
      const py = (Math.max(0, Math.min(100, y)) / 100) * nh;
      const gauche = Math.round(Math.min(nw - cote, Math.max(0, px - cote / 2)));
      const haut = Math.round(Math.min(nh - cote, Math.max(0, py - cote / 2)));
      const [base, requete = ''] = src.split('?');
      const v = new URLSearchParams(requete).get('v');
      const params = `${v ? `v=${encodeURIComponent(v)}&` : ''}crop=region&crop_left=${gauche}&crop_top=${haut}&crop_width=${cote}&crop_height=${cote}&width=480&height=480`;
      return {
        src: `${base}?${params}`,
        x: Math.round(((px - gauche) / cote) * 1000) / 10,
        y: Math.round(((py - haut) / cote) * 1000) / 10,
      };
    };

    const hydrateSchemaCrops = (scope = root) => {
      scope.querySelectorAll('[data-k-schema-crop]').forEach((img) => {
        if (img.dataset.kCropReady === 'true') return;
        const media = img.closest('.kFunnel__cardMedia--schema');
        if (!media) return;
        const xPct = Math.max(0, Math.min(100, Number(img.dataset.xPct) || 50));
        const yPct = Math.max(0, Math.min(100, Number(img.dataset.yPct) || 50));
        const marker = media.querySelector('.kFunnel__schemaMarker');

        const place = () => {
          const nw = img.naturalWidth;
          const nh = img.naturalHeight;
          const cw = media.clientWidth;
          const ch = media.clientHeight;
          if (!nw || !nh || !cw || !ch) return;

          // 31/10 : recadrage plus serre (environ 16 % du petit cote, entre 300 et 520 px de
          // l'image source) pour que le numero du repere reste lisible sur une carte de 160 px.
          const cropSide = Math.min(Math.min(nw, nh), Math.max(300, Math.min(520, Math.round(Math.min(nw, nh) * .16))));
          const scale = Math.max(cw / cropSide, ch / cropSide);
          const rw = nw * scale;
          const rh = nh * scale;

          let left = (cw / 2) - ((xPct / 100) * rw);
          let top = (ch / 2) - ((yPct / 100) * rh);
          left = Math.min(0, Math.max(cw - rw, left));
          top = Math.min(0, Math.max(ch - rh, top));

          img.style.width = rw + 'px';
          img.style.height = rh + 'px';
          img.style.left = left + 'px';
          img.style.top = top + 'px';

          if (marker) {
            marker.style.left = (left + ((xPct / 100) * rw)) + 'px';
            marker.style.top = (top + ((yPct / 100) * rh)) + 'px';
            marker.classList.add('is-place');
          }
          img.dataset.kCropReady = 'true';
        };

        if (img.complete) place();
        else img.addEventListener('load', place, { once: true });
      });
    };
    let grid = root.querySelector('.kFunnel__productsGrid');
    const countNode = root.querySelector('.kFunnel__count');
    const titleNode = root.querySelector('.kFunnel__resultTitle');
    const metaNode = root.querySelector('.kFunnel__resultMeta');
    const chipsNode = root.querySelector('.kFunnel__chips');
    const searchInput = root.querySelector('#kFunnelSearch');
    const filterToggle = root.querySelector('[data-k-filter-toggle]');
    const activeSummaryNode = root.querySelector('[data-k-active-summary]');
    const smartFilters = root.querySelector('[data-k-smart-filters]');
    const smartSector = root.querySelector('[data-k-smart-sector]');
    const smartBrand = root.querySelector('[data-k-smart-brand]');
    const smartModel = root.querySelector('[data-k-smart-model]');
    const smartCategory = root.querySelector('[data-k-smart-category]');
    const smartReset = root.querySelector('[data-k-smart-reset]');
    const smartClearAll = root.querySelector('[data-k-clear-all]');
    const smartDrawer = root.querySelector('[data-k-filter-drawer]');
    const smartOverlay = root.querySelector('[data-k-filter-overlay]');
    const smartDrawerCount = root.querySelector('[data-k-drawer-count]');
    const smartOpenButtons = [...root.querySelectorAll('[data-k-filter-open]')];
    const smartCloseButtons = [...root.querySelectorAll('[data-k-filter-close]')];
    let smartFinderData = null;
    let smartFlatParts = null;
    let smartPreviousFocus = null;
    const serverPaginationWrappers = [...root.querySelectorAll('.kFunnel__results .pagination-wrapper')];
    let applyRunId = 0;

    const normalize = (value) =>
      String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    const funnelCatalogue = (() => {
      try {
        return JSON.parse(document.getElementById('kFunnelCatalogue')?.textContent || '{}');
      } catch (error) {
        return {};
      }
    })();
    funnelCatalogue.marques = funnelCatalogue.marques || [];
    funnelCatalogue.modeles = funnelCatalogue.modeles || [];

    const normalizeOemQuery = (value) => {
      if (window.KrepiteSearch?.normalizeOemQuery) return window.KrepiteSearch.normalizeOemQuery(value);
      return String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/^\s*(?:ref(?:erence)?|oem|sku)\s*[:#=\-]?\s*/i, '')
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, '');
    };

    const normalizeOemValue = (value) => {
      if (window.KrepiteSearch?.normalizeOem) return window.KrepiteSearch.normalizeOem(value);
      return String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, '');
    };

    const looksTechnicalReference = (value) => {
      if (window.KrepiteSearch?.looksTechnical) return window.KrepiteSearch.looksTechnical(value);
      const compact = normalizeOemQuery(value);
      return compact.length >= 4 && compact.length <= 32 && /[0-9]/.test(compact);
    };

    const parseDimensionSearch = (value) =>
      window.KrepiteSearch?.parseDimensionQuery
        ? window.KrepiteSearch.parseDimensionQuery(value)
        : null;

    const escapeHtml = (value) =>
      String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char]));

    // Filtres GENERES depuis les donnees : la donnee Finder (vues eclatees) +
    // l'index des fiches publiees hors Finder (Dixneuf, Ten, futurs imports,
    // scripts/build_catalog_search_index.py). Aucune marque ni categorie codee ici.
    const mergeCatalogFacets = (finder, catalog) => {
      const data = { ...(finder || {}) };
      const finderSectors = smartSectorItems(finder);
      data.finderSector = finderSectors.length === 1 ? finderSectors[0].value : '';
      const brandSeen = new Set((data.brands || []).map((item) => String(item.handle || '')));
      data.brands = [...(data.brands || [])];
      Object.entries(catalog?.brands || {}).forEach(([handle, label]) => {
        if (brandSeen.has(handle)) return;
        brandSeen.add(handle);
        data.brands.push({ handle, label: String(label || handle) });
      });
      data.brands.sort((a, b) => String(a.label || a.handle).localeCompare(String(b.label || b.handle), 'fr'));
      const categorySeen = new Set((data.categories || []).map((item) => String(item.handle || '')));
      data.categories = (data.categories || []).map((item) => ({ ...item, sectors: item.sectors || (data.finderSector ? [data.finderSector] : []) }));
      Object.entries(catalog?.categories || {}).forEach(([handle, item]) => {
        if (categorySeen.has(handle)) return;
        categorySeen.add(handle);
        data.categories.push({ handle, label: String(item?.label || handle), sectors: item?.sectors || [] });
      });
      const sectors = new Map(finderSectors.map((item) => [item.value, item.label]));
      Object.entries(catalog?.sectors || {}).forEach(([handle, label]) => { if (!sectors.has(handle)) sectors.set(handle, String(label || handle)); });
      data.sectors = [...sectors.entries()].map(([handle, label]) => ({ handle, label }));
      data.catalogParts = catalog?.parts || [];
      // Libelles des familles et sous-familles du contrat du pipeline (index et finder-data).
      data.famillesContrat = { ...((finder && !Array.isArray(finder.familles) && finder.familles) || {}), ...(catalog?.familles || {}) };
      return data;
    };

    const loadSmartFinderData = async () => {
      if (smartFinderData) return smartFinderData;
      if (!window.KrepiteSearch?.loadFinderData) return null;
      const [finder, catalog] = await Promise.all([
        window.KrepiteSearch.loadFinderData(),
        window.KrepiteSearch.loadCatalogIndex ? window.KrepiteSearch.loadCatalogIndex() : null,
      ]);
      smartFinderData = mergeCatalogFacets(finder, catalog);
      return smartFinderData;
    };

    const smartParams = () => {
      const query = new URLSearchParams(window.location.search);
      return { sector: query.get('sector') || '', brand: query.get('brand') || '', model: query.get('model') || '', category: query.get('category') || '' };
    };

    const hasSmartFilters = () => {
      const value = smartParams();
      return Boolean(value.sector || value.brand || value.model || value.category);
    };

    const fillSmartSelect = (select, items, selectedValue, emptyLabel) => {
      if (!select) return;
      select.innerHTML = '';
      if (emptyLabel) { const empty = document.createElement('option'); empty.value = ''; empty.textContent = emptyLabel; select.appendChild(empty); }
      items.forEach((item) => { const option = document.createElement('option'); option.value = item.value; option.textContent = item.label; option.selected = item.value === selectedValue; select.appendChild(option); });
    };

    const smartSectorItems = (data) => {
      const declared = Array.isArray(data?.sectors) ? data.sectors : [];
      if (declared.length) {
        return declared
          .map((item) => ({
            value: String(item.handle || item.key || ''),
            label: String(item.label || item.name || item.handle || item.key || ''),
          }))
          .filter((item) => item.value && item.label);
      }
      if (String(data?.scope || '') === 'wood-multicategory') {
        return [{ value: 'poeles-a-bois', label: 'Poêles à bois' }];
      }
      return [];
    };

    // Secteur des pieces de la donnee Finder (qui n'en portent pas).
    const currentSectorHandle = (data) => {
      if (data && typeof data.finderSector === 'string') return data.finderSector;
      const items = smartSectorItems(data);
      return items.length === 1 ? items[0].value : '';
    };

    const flattenSmartParts = async () => {
      if (smartFlatParts) return smartFlatParts;
      const data = await loadSmartFinderData();
      const rows = [];
      Object.entries(data?.models || {}).forEach(([modelHandle, model]) => {
        (model?.candidate_parts || []).forEach((part) => {
          rows.push({ ...part, kind: 'part', sector_handle: part.sector_handle || part.sector || currentSectorHandle(data), model_handle: modelHandle, model_label: model.model_label || modelHandle, brand_handle: model.brand || '', url: part.canonical_target_published === true && part.canonical_url ? part.canonical_url : (part.product_handle ? '/products/' + part.product_handle : '') });
        });
      });
      (data?.catalogParts || []).forEach((part) => rows.push({ ...part, kind: 'part' }));
      smartFlatParts = rows;
      return rows;
    };

    // Repli (26/10) : les donnees du Finder ne portent que 7 categories (ancien decoupage) ;
    // une charniere ou un ressort y est classe ailleurs. Le titre de la piece fait foi.
    const titreDeLaFamille = (titre, famille) => {
      const mots = categoryMatches[famille] || [];
      const t = normalize(titre || '');
      return mots.some((w) => commenceMot(t, w));
    };

    const smartCategoryMatches = (partCategory, wantedCategory) => {
      const part = String(partCategory || '');
      const wanted = String(wantedCategory || '');
      if (!wanted) return true;
      if (part === wanted) return true;
      // 26/10 : les familles viennent de familles_json (cle « joints », « vitrage »...)
      // alors que les pieces du catalogue Finder portent une categorie au singulier
      // (« joint », « vitre », « plaque-isolation ») : un mot de la categorie de la piece
      // qui appartient aux mots de la famille suffit.
      const mots = categoryMatches[wanted] || [];
      return normalize(part).split(' ').some((w) => mots.includes(w));
    };

    const smartTextQuery = (rawQuery) => {
      const normalized = normalize(rawQuery);
      if (!normalized) return '';
      const generic = new Set([
        'a', 'au', 'aux', 'de', 'des', 'du', 'la', 'le', 'les',
        'poele', 'poeles', 'bois',
        'piece', 'pieces', 'detachee', 'detachees',
        'compatible', 'compatibles', 'pour',
      ]);
      const useful = normalized.split(' ').filter((token) => token && !generic.has(token));
      return useful.join(' ').trim() || normalized;
    };

    // options.sansAppareil (31/10) : memes pieces sans le cadrage marque/modele, pour lister
    // les marques et modeles presents dans les resultats (selecteur « Pour quel appareil ? »).
    const smartMatches = async (rawQuery, state, options = {}) => {
      const selected = options.sansAppareil ? { ...smartParams(), brand: '', model: '' } : smartParams();
      const textQuery = smartTextQuery(rawQuery);
      let parts;

      if (textQuery && window.KrepiteSearch?.lookupText) {
        parts = (await window.KrepiteSearch.lookupText(textQuery, 5000))
          .filter((item) => item && item.kind === 'part');
      } else {
        parts = await flattenSmartParts();
      }

      if (!parts.length && state?.category) {
        parts = await flattenSmartParts();
      }

      const stateBrand = options.sansAppareil ? '' : String(state?.brandHandle || '').replace(/^brand-/, '');
      const stateModel = options.sansAppareil ? '' : String(state?.modelHandle || '').replace(/^model-/, '');
      const stateCategory = String(state?.category || '');

      return parts.filter((part) => {
        const partSector = String(part.sector_handle || part.sector || currentSectorHandle(smartFinderData) || '');
        if (selected.sector && partSector && partSector !== selected.sector) return false;
        if (selected.brand && !marquesDeLaPiece(part).includes(selected.brand)) return false;
        if (selected.model && !modelesDeLaPiece(part).includes(selected.model)) return false;
        if (selected.category && !smartCategoryMatches(part.category, selected.category) && !titreDeLaFamille(part.title, selected.category)) return false;
        if (stateBrand && !marquesDeLaPiece(part).includes(stateBrand)) return false;
        if (stateModel && !modelesDeLaPiece(part).includes(stateModel)) return false;
        if (stateCategory && !smartCategoryMatches(part.category, stateCategory) && !titreDeLaFamille(part.title, stateCategory)) return false;
        return true;
      });
    };

    const applySmartState = async (state) => {
      const data = await loadSmartFinderData();
      if (!data) return state;
      const selected = smartParams();
      const brands = new Map((data.brands || []).map((brand) => [String(brand.handle || ''), brand]));
      const categories = new Map((data.categories || []).map((category) => [String(category.handle || ''), category]));
      const models = data.models || {};
      if (selected.sector === 'poeles-a-bois') {
        state.device = 'bois';
        state.deviceLabel = 'Poêle à bois';
      }
      if (selected.brand && brands.has(selected.brand)) { const brand = brands.get(selected.brand); state.brand = selected.brand; state.brandLabel = brand.label || selected.brand; state.brandHandle = 'brand-' + selected.brand; }
      if (selected.model && models[selected.model]) { const model = models[selected.model]; const brand = brands.get(String(model.brand || '')); state.model = normalize(model.model_label || selected.model); state.modelLabel = model.model_label || selected.model; state.modelHandle = 'model-' + selected.model; state.brand = String(model.brand || state.brand || ''); state.brandLabel = brand?.label || state.brandLabel || state.brand; state.brandHandle = state.brand ? 'brand-' + state.brand : state.brandHandle; }
      if (selected.category && categories.has(selected.category)) { const category = categories.get(selected.category); state.category = selected.category; state.categoryLabel = category.label || selected.category; state.usesFamilyCollection = false; }
      if (state.modelHandle) state.collectionHandle = state.modelHandle; else if (state.brandHandle) state.collectionHandle = state.brandHandle;
      return state;
    };

    const refreshSmartModels = (selectedModel = '') => {
      const data = smartFinderData || {};
      const brandHandle = smartBrand?.value || '';
      // 01/11 (audit 30 profils) : une marque tapee dans la recherche (« joint poele Lotus »)
      // met ses modeles en tete de la liste, sans masquer les autres.
      const motsRequete = normalize(searchInput?.value || new URLSearchParams(window.location.search).get('q') || '').split(' ').filter(Boolean);
      const marqueRequete = brandHandle ? '' : (Object.values(data.models || {}).map((m) => String(m?.brand || '')).find((h) => h && motsRequete.includes(normalize(h.replace(/-/g, ' ')))) || '');
      const items = Object.entries(data.models || {}).filter((entry) => !brandHandle || String(entry[1]?.brand || '') === brandHandle).map((entry) => ({ value: entry[0], label: String(entry[1]?.model_label || entry[0]), tete: marqueRequete && String(entry[1]?.brand || '') === marqueRequete ? 0 : 1 })).sort((a, b) => a.tete - b.tete || a.label.localeCompare(b.label, 'fr'));
      fillSmartSelect(smartModel, items, selectedModel, 'Tous les modèles');
      if (smartModel) smartModel.disabled = items.length === 0;
    };

    const smartSelectedText = (select) => select?.selectedOptions?.[0]?.value ? select.selectedOptions[0].textContent.trim() : '';

    const updateSmartToolbar = () => {
      const selected = smartParams();
      const labels = { sector: smartSelectedText(smartSector), brand: smartSelectedText(smartBrand), model: smartSelectedText(smartModel), category: smartSelectedText(smartCategory) };
      smartOpenButtons.forEach((button) => {
        const key = button.getAttribute('data-k-filter-open');
        if (!key || key === 'all') return;
        const label = button.querySelector('[data-k-filter-label="' + key + '"]');
        const fallback = key === 'sector' ? 'Équipement' : key === 'brand' ? 'Marque' : key === 'model' ? 'Modèle' : 'Type de pièce';
        if (label) label.textContent = labels[key] || fallback;
        button.title = labels[key] || fallback;
        button.classList.toggle('is-active', Boolean(labels[key]));
      });
      const activeCount = [selected.sector, selected.brand, selected.model, selected.category].filter(Boolean).length;
      const activeSearch = Boolean(cleanSearchQuery(searchInput?.value || new URLSearchParams(window.location.search).get('q') || ''));
      root.querySelectorAll('[data-k-filter-badge]').forEach((badge) => { badge.textContent = String(activeCount); badge.hidden = activeCount === 0; });
      root.querySelector('[data-k-filter-open="all"]')?.classList.toggle('is-active', activeCount > 0);
      if (smartClearAll) smartClearAll.disabled = activeCount === 0 && !activeSearch;
      if (smartReset) smartReset.disabled = activeCount === 0 && !activeSearch;
      tiroirMajValeurs();
    };

    // Bouton du tiroir : « Afficher N pieces » (nombre reel des resultats filtres).
    let resNombre = null;
    const syncSmartDrawerCount = () => {
      const bouton = root.querySelector('[data-k-tiroir-afficher]');
      if (!bouton) return;
      let n = resNombre;
      if (n === null) {
        const raw = String(countNode?.textContent || '').match(/\d+/);
        n = raw ? Number(raw[0]) : null;
      }
      bouton.textContent = n === null ? 'Afficher les pièces' : n === 0 ? 'Aucune pièce' : `Afficher ${n} pièce${n > 1 ? 's' : ''}`;
    };

    // ---------- Tiroir « Tous les filtres » : un niveau a la fois (31/10) ----------
    const tiroirN1 = root.querySelector('[data-k-tiroir-niveau1]');
    const tiroirN2 = root.querySelector('[data-k-tiroir-niveau2]');
    const tiroirValeurs = root.querySelector('[data-k-tiroir-valeurs]');
    const tiroirCherche = root.querySelector('[data-k-tiroir-cherche]');
    const tiroirChamp = root.querySelector('[data-k-tiroir-cherche-champ]');
    const tiroirChercheLabel = root.querySelector('[data-k-tiroir-cherche-label]');
    const tiroirRetour = root.querySelector('[data-k-tiroir-retour]');
    const tiroirTitre = root.querySelector('[data-k-tiroir-titre]');
    const TIROIR_TITRES = { sector: 'Équipement', brand: 'Marque', model: 'Modèle', category: 'Type de pièce' };
    const TIROIR_RECHERCHE = { sector: 'Rechercher un équipement', brand: 'Rechercher une marque', model: 'Rechercher un modèle', category: 'Rechercher un type de pièce' };
    const TIROIR_TOUS = { sector: 'Tous les équipements', brand: 'Toutes les marques', model: 'Tous les modèles', category: 'Tous les types' };
    const tiroirSelect = (cle) => ({ sector: smartSector, brand: smartBrand, model: smartModel, category: smartCategory })[cle] || null;
    let tiroirCle = '';
    const COCHE = '<span class="kTiroir__coche" aria-hidden="true"><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m2.5 6.2 2.3 2.3 4.7-4.9"/></svg></span>';

    function tiroirMajValeurs() {
      Object.keys(TIROIR_TITRES).forEach((cle) => {
        const noeud = root.querySelector(`[data-k-tiroir-valeur="${cle}"]`);
        if (noeud) noeud.textContent = smartSelectedText(tiroirSelect(cle)) || (cle === 'brand' ? 'Toutes' : 'Tous');
      });
    }

    // Valeurs d'un filtre, lues dans les donnees (jamais de liste ici) ; les modeles sont
    // groupes par marque, limites a la marque choisie s'il y en a une.
    const tiroirItems = (cle) => {
      const data = smartFinderData || {};
      if (cle === 'sector') return smartSectorItems(data);
      if (cle === 'category') return smartCategoryItems(data, smartSector?.value || '');
      const marques = new Map((data.brands || []).map((item) => [String(item.handle || ''), String(item.label || item.handle || '')]));
      if (cle === 'brand') {
        return [...marques.entries()].filter(([value, label]) => value && label).map(([value, label]) => ({ value, label }));
      }
      const marque = smartBrand?.value || '';
      return Object.entries(data.models || {})
        .filter(([, model]) => !marque || String(model?.brand || '') === marque)
        .map(([value, model]) => {
          const groupe = marques.get(String(model?.brand || '')) || String(model?.brand || '');
          return { value, label: modeleCourt(String(model?.model_label || value), groupe), groupe };
        })
        .sort((a, b) => a.groupe.localeCompare(b.groupe, 'fr') || a.label.localeCompare(b.label, 'fr', { numeric: true }));
    };

    const tiroirRendreValeurs = () => {
      if (!tiroirValeurs || !tiroirCle) return;
      const select = tiroirSelect(tiroirCle);
      const courant = select?.value || '';
      const filtre = normalize(tiroirChamp?.value || '');
      const items = tiroirItems(tiroirCle).filter((item) => !filtre || normalize(`${item.groupe || ''} ${item.label}`).includes(filtre));
      let groupe = null;
      const lignes = [];
      if (!filtre) lignes.push(`<button class="kTiroir__valeur" type="button" data-k-tiroir-choix="" aria-pressed="${courant === ''}">${COCHE}<span>${escapeHtml(TIROIR_TOUS[tiroirCle])}</span></button>`);
      items.forEach((item) => {
        if (item.groupe && item.groupe !== groupe) {
          groupe = item.groupe;
          lignes.push(`<p class="kTiroir__groupe">${escapeHtml(groupe)}</p>`);
        }
        lignes.push(`<button class="kTiroir__valeur" type="button" data-k-tiroir-choix="${escapeHtml(item.value)}" aria-pressed="${item.value === courant}">${COCHE}<span>${escapeHtml(item.label)}</span></button>`);
      });
      if (!items.length) lignes.push('<p class="kTiroir__aucun">Rien ne correspond. Essayez un autre mot.</p>');
      tiroirValeurs.innerHTML = lignes.join('');
    };

    const tiroirNiveau1 = (focusCle = '') => {
      tiroirCle = '';
      if (tiroirN1) tiroirN1.hidden = false;
      if (tiroirN2) tiroirN2.hidden = true;
      if (tiroirRetour) tiroirRetour.hidden = true;
      if (tiroirTitre) tiroirTitre.textContent = 'Filtres';
      tiroirMajValeurs();
      if (focusCle) root.querySelector(`[data-k-tiroir-ouvrir="${focusCle}"]`)?.focus?.();
    };

    const tiroirNiveau2 = (cle) => {
      if (!TIROIR_TITRES[cle]) return tiroirNiveau1();
      tiroirCle = cle;
      if (tiroirN1) tiroirN1.hidden = true;
      if (tiroirN2) tiroirN2.hidden = false;
      if (tiroirRetour) tiroirRetour.hidden = false;
      if (tiroirTitre) tiroirTitre.textContent = TIROIR_TITRES[cle];
      const nombre = tiroirItems(cle).length;
      if (tiroirCherche) tiroirCherche.hidden = nombre <= 10;
      if (tiroirChamp) {
        tiroirChamp.value = '';
        tiroirChamp.placeholder = TIROIR_RECHERCHE[cle];
      }
      if (tiroirChercheLabel) tiroirChercheLabel.textContent = TIROIR_RECHERCHE[cle];
      tiroirRendreValeurs();
      const corps = smartDrawer?.querySelector('.kTiroir__corps');
      if (corps) corps.scrollTop = 0;
      window.requestAnimationFrame(() => {
        const cible = nombre > 10 ? tiroirChamp : tiroirValeurs?.querySelector('[aria-pressed="true"]') || tiroirValeurs?.querySelector('button');
        cible?.focus?.({ preventScroll: true });
      });
    };

    const tiroirChoisir = (valeur) => {
      const cle = tiroirCle;
      const select = tiroirSelect(cle);
      if (!select) return;
      if (cle === 'model' && valeur && ![...select.options].some((option) => option.value === valeur)) refreshSmartModels(valeur);
      select.value = valeur;
      // Les ecouteurs existants appliquent le filtre (URL + resultats).
      select.dispatchEvent(new Event('change', { bubbles: true }));
      if (cle === 'model' && valeur) memoriserAppareil(valeur);
      tiroirNiveau1(cle);
    };

    tiroirN1?.addEventListener('click', (event) => {
      const bouton = event.target instanceof Element ? event.target.closest('[data-k-tiroir-ouvrir]') : null;
      if (bouton) tiroirNiveau2(bouton.getAttribute('data-k-tiroir-ouvrir'));
    });
    tiroirValeurs?.addEventListener('click', (event) => {
      const bouton = event.target instanceof Element ? event.target.closest('[data-k-tiroir-choix]') : null;
      if (bouton) tiroirChoisir(bouton.getAttribute('data-k-tiroir-choix') || '');
    });
    tiroirChamp?.addEventListener('input', tiroirRendreValeurs);
    tiroirRetour?.addEventListener('click', () => tiroirNiveau1(tiroirCle));

    const closeSmartDrawer = () => {
      if (!smartDrawer) return;
      smartDrawer.classList.remove('is-open'); smartDrawer.setAttribute('aria-hidden', 'true'); smartDrawer.inert = true;
      if (smartOverlay) smartOverlay.hidden = true;
      smartOpenButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      smartPreviousFocus?.focus?.(); smartPreviousFocus = null;
    };

    const openSmartDrawer = (section) => {
      if (!smartDrawer) return;
      smartPreviousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      smartDrawer.classList.add('is-open'); smartDrawer.setAttribute('aria-hidden', 'false'); smartDrawer.inert = false;
      if (smartOverlay) smartOverlay.hidden = false;
      smartOpenButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      syncSmartDrawerCount();
      if (section && section !== 'all' && TIROIR_TITRES[section]) {
        tiroirNiveau2(section);
        return;
      }
      tiroirNiveau1();
      window.requestAnimationFrame(() => {
        smartDrawer.querySelector('[data-k-tiroir-ouvrir]')?.focus?.({ preventScroll: true });
      });
    };

    // Types de piece du secteur choisi (tous si aucun secteur).
    const smartCategoryItems = (data, sector) => (data?.categories || [])
      .filter((item) => !sector || !(item.sectors || []).length || item.sectors.includes(sector))
      .map((item) => ({ value: String(item.handle || ''), label: String(item.label || item.handle || '') }))
      .filter((item) => item.value && item.label)
      .sort((a, b) => a.label.localeCompare(b.label, 'fr'));

    const initSmartFilters = async () => {
      const data = await loadSmartFinderData();
      if (!data || !smartFilters || !smartSector || !smartBrand || !smartModel || !smartCategory) return false;
      const selected = smartParams();
      const sectors = smartSectorItems(data);
      const brands = (data.brands || []).map((item) => ({ value: String(item.handle || ''), label: String(item.label || item.handle || '') })).filter((item) => item.value && item.label);
      const categories = smartCategoryItems(data, selected.sector);
      fillSmartSelect(smartSector, sectors, selected.sector, 'Tous les équipements');
      fillSmartSelect(smartBrand, brands, selected.brand, 'Toutes les marques');
      if (selected.model && data.models?.[selected.model]?.brand && smartBrand) smartBrand.value = String(data.models[selected.model].brand || '');
      refreshSmartModels(selected.model);
      fillSmartSelect(smartCategory, categories, selected.category, 'Tous les types');
      smartFilters.hidden = false; root.classList.add('kFunnel--smart-filters'); updateSmartToolbar();
      return true;
    };
    // Familles lues dans les donnees du pipeline (familles_json, 26/10) : mots, libelles,
    // mot de requete et expressions. Plus aucune categorie ecrite ici.
    const categoryMatches = {};
    const categoryLabels = {};
    const categoryQueryWords = {};
    const customerVocabularyCategories = [];
    const categoryContextStopWords = {};
    (funnelCatalogue.familles || []).forEach((f) => {
      const mots = (f.m || []).map(normalize).filter(Boolean);
      if (!f.c || !mots.length) return;
      categoryMatches[f.c] = mots;
      categoryLabels[f.c] = f.l || f.c;
      categoryQueryWords[f.c] = mots.includes(normalize(f.c)) ? normalize(f.c) : mots[0];
      const contexte = new Set();
      (f.e || []).forEach((tous) => {
        const mots_expr = (tous || []).map(normalize).filter(Boolean);
        if (!mots_expr.length) return;
        customerVocabularyCategories.push({ category: f.c, tous: mots_expr });
        mots_expr.forEach((w) => contexte.add(w));
      });
      categoryContextStopWords[f.c] = [...contexte];
    });
    const contientMot = (texte, mot) => ` ${texte} `.includes(` ${mot} `);
    const commenceMot = (texte, mot) => ` ${texte}`.includes(` ${mot}`);

    const searchSynonymGroups = [
      ['ressort', 'ressorts', 'spring', 'springs'],
      ['joint', 'joints', 'seal', 'seals', 'gasket', 'gaskets'],
      ['vitre', 'vitres', 'vitrage', 'glass'],
      ['vermiculite', 'brique', 'briques', 'isolation', 'insulation'],
      ['deflecteur', 'deflecteurs', 'deflect', 'baffle'],
      ['grille', 'grilles', 'grate'],
      ['poignee', 'poignees', 'poigne', 'handle', 'handles'],
      ['porte', 'door'],
      ['charniere', 'charnieres', 'hinge', 'hinges'],
      ['cendrier', 'cendre', 'cendres', 'ash', 'ashpan'],
      ['vis', 'screw', 'screws'],
      ['ecrou', 'ecrous', 'nut', 'nuts'],
      ['rondelle', 'rondelles', 'washer', 'washers'],
      ['plaque', 'plaques', 'plate', 'plates'],
    ];

    const searchStopWords = new Set([
      'a',
      'au',
      'aux',
      'avec',
      'bois',
      'compatible',
      'compatibles',
      'de',
      'des',
      'detachee',
      'detachees',
      'du',
      'la',
      'le',
      'les',
      'marque',
      'model',
      'modele',
      'oem',
      'piece',
      'pieces',
      'poele',
      'poeles',
      'pour',
      'ref',
      'reference',
      'sku',
    ]);

    const collectionCache = new Map();

    const setFiltersOpen = (isOpen) => {
      root.classList.toggle('is-filters-open', isOpen);
      filterToggle?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    };

    const ensureProductsGrid = () => {
      if (grid) return grid;
      const results = root.querySelector('.kFunnel__classique') || root.querySelector('.kFunnel__results');
      if (!results) return null;
      const nextGrid = document.createElement('ul');
      nextGrid.className = 'kFunnel__productsGrid';
      nextGrid.setAttribute('role', 'list');
      const emptyState = results.querySelector(':scope > .kFunnel__empty');
      if (emptyState) {
        emptyState.replaceWith(nextGrid);
      } else {
        results.appendChild(nextGrid);
      }
      grid = nextGrid;
      return grid;
    };

    filterToggle?.addEventListener('click', () => {
      setFiltersOpen(!root.classList.contains('is-filters-open'));
    });

    const withPreview = (href) => {
      if (!previewThemeId || !href || href.startsWith('#')) return href;
      const url = new URL(href, window.location.origin);
      url.searchParams.set('preview_theme_id', previewThemeId);
      return `${url.pathname}${url.search}${url.hash}`;
    };

    const setLinkQuery = (href, query) => {
      const url = new URL(href, window.location.origin);
      url.searchParams.delete('options');
      url.searchParams.set('view', 'trouver-piece-v3');
      url.searchParams.set('q', query);
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
      return `${url.pathname}${url.search}${url.hash}`;
    };

    const cleanSearchQuery = (value) => {
      const raw = String(value || '').trim();
      if (!raw) return '';

      try {
        const parsed = new URL(raw, window.location.origin);
        if (parsed.pathname.includes('/pages/trouver-ma-piece')) {
          return (parsed.searchParams.get('q') || '').trim();
        }
      } catch (_error) {
        // Plain words are expected here; URL parsing is only a cleanup path.
      }

      if (raw.includes('/pages/trouver-ma-piece') || raw.includes('krepite.fr/') || raw.includes('myshopify.com/')) {
        return '';
      }

      return raw;
    };

    const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    const removePhrase = (value, phrase) => {
      const normalizedPhrase = normalize(phrase);
      if (!normalizedPhrase) return value;
      return value.replace(new RegExp(`(^| )${escapeRegExp(normalizedPhrase)}(?= |$)`, 'g'), ' ');
    };

    const expandSearchToken = (token) => {
      const normalizedToken = normalize(token);
      const synonymGroup = searchSynonymGroups.find((group) => group.includes(normalizedToken));
      return synonymGroup || [normalizedToken];
    };

    const detectCustomerVocabularyCategory = (query) => {
      for (const rule of customerVocabularyCategories) {
        if (rule.tous.every((w) => contientMot(query, w))) return rule.category;
      }
      for (const category of Object.keys(categoryMatches)) {
        if (categoryMatches[category].some((w) => contientMot(query, w))) return category;
      }
      return '';
    };

    const buildFreeTextGroups = (query, state) => {
      let residual = ` ${query} `;
      const knownPhrases = [
        'poele bois',
        'poeles bois',
        'poele a bois',
        'poele',
        'poeles',
        'bois',
        state.brand,
        state.brandLabel,
        state.model,
        state.modelLabel,
      ];

      if (state.model) knownPhrases.push(state.model.replace(/\s+/g, ''));
      if (state.category) {
        knownPhrases.push(state.category, state.categoryLabel, categoryQueryWords[state.category]);
        (categoryMatches[state.category] || []).forEach((word) => knownPhrases.push(word));
        (categoryContextStopWords[state.category] || []).forEach((word) => knownPhrases.push(word));
      }

      knownPhrases.filter(Boolean).forEach((phrase) => {
        residual = removePhrase(residual, phrase);
      });

      const tokens = residual
        .replace(/\s+/g, ' ')
        .trim()
        .split(' ')
        .filter((token) => token.length > 1 && !searchStopWords.has(token));

      const uniqueTokens = [...new Set(tokens)];
      return uniqueTokens.map(expandSearchToken);
    };

    root.querySelectorAll('a[href]').forEach((link) => {
      link.setAttribute('href', withPreview(link.getAttribute('href')));
    });

    root.querySelectorAll('form').forEach((form) => {
      if (!previewThemeId || form.querySelector('input[name="preview_theme_id"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'preview_theme_id';
      input.value = previewThemeId;
      form.appendChild(input);
    });

    const buildState = (rawQuery) => {
      const cleanedRawQuery = cleanSearchQuery(rawQuery);
      const query = normalize(cleanedRawQuery);
      const state = {
        rawQuery: cleanedRawQuery,
        query,
        device: '',
        deviceLabel: '',
        collectionHandle: 'sector-poeles-a-bois',
        usesFamilyCollection: false,
        brand: '',
        brandLabel: '',
        brandHandle: '',
        model: '',
        modelLabel: '',
        modelHandle: '',
        category: '',
        categoryLabel: '',
        freeTextGroups: [],
        freeTextLabel: '',
        dimensionQuery: parseDimensionSearch(cleanedRawQuery),
        technicalReference: looksTechnicalReference(cleanedRawQuery),
        oemKey: normalizeOemQuery(cleanedRawQuery),
      };

      if (query.includes('poele bois') || query.includes('poeles bois') || query.includes('poele a bois')) {
        state.device = 'bois';
        state.deviceLabel = 'Poêle à bois';
      }

      // Marque et modele lus dans les donnees du pipeline (kFunnelCatalogue, 25/10) :
      // mot entier exige, et pour le modele le libelle le plus long gagne.
      const paddedQuery = ` ${query} `;
      const brandHit = funnelCatalogue.marques.find((m) => paddedQuery.includes(` ${normalize(m.l)} `) || paddedQuery.includes(` ${normalize(m.h)} `));
      if (brandHit) {
        state.brand = normalize(brandHit.h);
        state.brandLabel = brandHit.l;
        state.brandHandle = `brand-${brandHit.h}`;
      }
      let bestLength = 0;
      funnelCatalogue.modeles.forEach((m) => {
        const brandLabel = normalize(m.bl);
        const candidates = [normalize(m.l).replace(new RegExp(`^${brandLabel} `), ''), ...(m.a || []).map(normalize)];
        candidates.forEach((candidate) => {
          if (candidate.length < 2) return;
          const compact = candidate.replace(/\s+/g, '');
          const hit = paddedQuery.includes(` ${candidate} `) || (compact !== candidate && paddedQuery.includes(` ${compact} `));
          if (!hit || candidate.length <= bestLength) return;
          bestLength = candidate.length;
          state.model = candidate;
          state.modelLabel = m.l;
          state.modelHandle = m.h;
          state.brand = normalize(m.b);
          state.brandLabel = m.bl;
          state.brandHandle = `brand-${m.b}`;
          state.device = 'bois';
          state.deviceLabel = 'Poêle à bois';
        });
      });

      const customerCategory = detectCustomerVocabularyCategory(query);

      state.category = customerCategory;
      state.categoryLabel = categoryLabels[state.category] || '';
      state.freeTextGroups = buildFreeTextGroups(query, state);
      state.freeTextLabel = state.freeTextGroups.map((group) => group[0]).join(' ');

      if (state.dimensionQuery) {
        state.freeTextGroups = [];
        state.freeTextLabel = '';
      }

      // Un modele reconnu en mot entier (libelle ou alias, ex. « c8 ») n'est pas une reference.
      if (state.modelHandle) state.technicalReference = false;
      if (state.technicalReference) {
        state.collectionHandle = 'sector-poeles-a-bois';
        state.brand = '';
        state.brandLabel = '';
        state.brandHandle = '';
        state.model = '';
        state.modelLabel = '';
        state.modelHandle = '';
        state.category = '';
        state.categoryLabel = '';
        state.freeTextGroups = [];
        state.freeTextLabel = '';
      } else if (state.modelHandle) {
        state.collectionHandle = state.modelHandle;
      } else if (state.brandHandle) {
        state.collectionHandle = state.brandHandle;
      } else if (state.category) {
        state.collectionHandle = 'sector-poeles-a-bois';
        state.usesFamilyCollection = false;
      }

      return state;
    };

    const productText = (product) => normalize([
      product.title,
      product.handle,
      product.body_html,
      product.product_type,
      product.vendor,
      product.tags,
      ...(product.variants || []).map((variant) => variant?.sku || ''),
    ].filter(Boolean).join(' '));

    const productReferenceKeys = (product) =>
      [...new Set((product.variants || [])
        .map((variant) => normalizeOemValue(variant?.sku || ''))
        .filter(Boolean))];

    const productMatches = (product, state) => {
      const text = productText(product);
      if (text.includes('non vendu')) return false;
      if (state.technicalReference && state.oemKey) {
        return productReferenceKeys(product).includes(state.oemKey);
      }
      if (state.dimensionQuery) {
        const dimensionSource = [
          product.title,
          product.body_html,
          product.product_type,
          product.tags,
        ].filter(Boolean).join(' ');
        if (!window.KrepiteSearch?.matchesDimensionText?.(dimensionSource, state.dimensionQuery)) return false;
      }
      const hasKnownToken = Boolean(state.device || state.brand || state.model || state.category);
      if (state.category && !state.usesFamilyCollection) {
        const words = categoryMatches[state.category] || [normalize(state.category)];
        if (!words.some((word) => commenceMot(text, word))) return false;
      }
      if (state.freeTextGroups?.length) {
        const matchesFreeText = state.freeTextGroups.every((group) =>
          group.some((word) => text.includes(word))
        );
        if (!matchesFreeText) return false;
      }
      if (!hasKnownToken && state.query && !state.freeTextGroups?.length) return text.includes(state.query);
      return true;
    };

    const productUrl = (handle) => {
      const url = new URL(`/products/${handle}`, window.location.origin);
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
      return `${url.pathname}${url.search}`;
    };

    // Photo de la fiche Shopify (/products/<handle>.js), une requete par carte
    // VISIBLE seulement ; sans photo, la carte garde « Photo à venir ».
    const lazyPhotoObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        lazyPhotoObserver.unobserve(entry.target);
        loadLazyPhoto(entry.target);
      });
    }, { rootMargin: '200px' }) : null;

    const loadLazyPhoto = (node) => {
      const handle = node.getAttribute('data-k-lazy-photo');
      if (!handle) return;
      fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          const src = product && (product.featured_image || (product.images || [])[0]);
          if (!src || !node.isConnected) return;
          const img = document.createElement('img');
          img.src = String(src).replace(/^\/\//, 'https://') + (String(src).includes('?') ? '&' : '?') + 'width=600';
          img.alt = String(product.title || '');
          img.width = 600; img.height = 600; img.loading = 'lazy'; img.decoding = 'async';
          node.className = node.classList.contains('kCarte__media') ? 'kFunnel__cardMedia kCarte__media' : 'kFunnel__cardMedia';
          node.removeAttribute('data-k-lazy-photo');
          node.replaceChildren(img);
        })
        .catch(() => {});
    };

    const hydrateLazyPhotos = (grid) => {
      grid.querySelectorAll('[data-k-lazy-photo]').forEach((node) => {
        if (lazyPhotoObserver) lazyPhotoObserver.observe(node); else loadLazyPhoto(node);
      });
    };

    // Carte (31/10) : une seule action, toute la carte est le lien ; le titre est le nom
    // du lien. Reference en texte discret, prix valide ou « Sur devis » (commerceDisplay).
    const renderCard = (product) => {
      const sku = product.variants?.[0]?.sku || '';
      const title = product.title || product.handle;
      const href = product._url || productUrl(product.handle);
      const image = product._previewImage || null;
      const imageSrc = resolveFinderImageSrc(image);
      const imageKind = String(image?.kind || '');
      const imageWidth = Math.max(1, Number(image?.width) || 600);
      const imageHeight = Math.max(1, Number(image?.height) || 600);

      const highlight = product._highlight || {};
      const hasSchemaFallback = !imageSrc
        && product._schemaImage
        && highlight.enabled === true
        && Number.isFinite(Number(highlight.x_pct))
        && Number.isFinite(Number(highlight.y_pct));
      const schemaSrc = hasSchemaFallback ? resolveFinderAssetSrc(product._schemaImage) : '';
      const placeholderIcon = '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 5.5h16v13H4z"/><path d="m7 15 3.2-3.2 2.4 2.4 1.7-1.7L18 16"/><circle cx="15.5" cy="9" r="1.4"/></svg>';

      // Les images sont decoratives : le nom de la carte est son titre.
      const media = imageSrc
        ? `<div class="kFunnel__cardMedia kCarte__media${imageKind === 'schema_crop' ? ' kFunnel__cardMedia--schema' : ''}">
            <img src="${escapeHtml(imageSrc)}" alt="" width="${imageWidth}" height="${imageHeight}" loading="lazy" decoding="async">
          </div>`
        : schemaSrc && schemaCdn(schemaSrc, product._schemaDims, highlight)
        ? (() => {
            // 02/11 (lot 4 A) : la planche est recadree par le CDN autour du repere (meme cadrage que
            // hydrateSchemaCrops), servie a 480 px : 15 a 40 Ko au lieu de la planche entiere
            // (110 a 165 Ko), affichee des le premier rendu (plus d'attente du script : element LCP).
            const c = schemaCdn(schemaSrc, product._schemaDims, highlight);
            return `<div class="kFunnel__cardMedia kFunnel__cardMedia--schema kCarte__media">
            <img class="kFunnel__schemaCdn" src="${escapeHtml(c.src)}" alt="" width="480" height="480" loading="lazy" decoding="async">
            <span class="kFunnel__schemaMarker is-place" aria-hidden="true" style="left:${c.x}%;top:${c.y}%"></span>
          </div>`;
          })()
        : schemaSrc
        ? `<div class="kFunnel__cardMedia kFunnel__cardMedia--schema kCarte__media">
            <img src="${escapeHtml(schemaSrc)}" alt="" width="600" height="600" loading="lazy" decoding="async" data-k-schema-crop data-x-pct="${Number(highlight.x_pct)}" data-y-pct="${Number(highlight.y_pct)}">
            <span class="kFunnel__schemaMarker" aria-hidden="true"></span>
          </div>`
        : product._standalone && product.handle
        ? `<div class="kFunnel__cardPlaceholder kCarte__media" data-k-lazy-photo="${escapeHtml(product.handle)}">
            ${placeholderIcon}<span><strong>Photo à venir</strong></span>
          </div>`
        : `<div class="kFunnel__cardPlaceholder kCarte__media">
            ${placeholderIcon}<span><strong>Photo à venir</strong></span>
          </div>`;
      const commerce = product._commerce || null;
      const prix = commerce && commerce.kind === 'price'
        ? `<p class="kCarte__prix">${escapeHtml(commerce.label)}</p>`
        : commerce && commerce.kind === 'quote'
        ? '<p class="kCarte__prix kCarte__prix--devis">Obtenir mon prix</p>' // 02/11 (passe « chaleur ») : l'action, en bois, plus « Sur devis » en gris
        : '';
      const repere = product._repere && schemaSrc ? ` · repère ${escapeHtml(product._repere)}` : '';
      return `
        <li class="kFunnel__productItem" data-k-product-text="${escapeHtml(productText(product))}">
          <article class="kCarte">
            ${media}
            <div class="kCarte__corps">
              <p class="kCarte__titre"><a class="kCarte__lien" href="${escapeHtml(href)}" data-k-preview-link>${escapeHtml(title)}</a></p>
              ${sku ? `<p class="kCarte__ref">Réf. ${escapeHtml(sku)}${repere}</p>` : ''}
              ${prix}
            </div>
          </article>
        </li>`;
    };

    const renderEmptyCard = (state) => {
      const technical = Boolean(state?.technicalReference && state?.rawQuery);
      const dimensional = Boolean(state?.dimensionQuery && state?.rawQuery);
      const title = dimensional
        ? 'Aucune pièce avec cette taille documentée'
        : technical
        ? 'Référence introuvable dans le catalogue en ligne'
        : 'Vous ne trouvez pas votre pièce ?';
      const text = dimensional
        ? `Nous ne trouvons pas encore « ${escapeHtml(state.rawQuery)} » dans les dimensions documentées. Les formats mm/cm, Ø, M6x20, 420x310 et les décimales avec virgule sont normalisés automatiquement.`
        : technical
        ? `Nous ne trouvons pas encore « ${escapeHtml(state.rawQuery)} ». Les espaces, tirets, points et barres sont déjà ignorés lors de la recherche de référence.`
        : 'Essayez le nom de la pièce (joint, vitre, grille…), ou partez du modèle de votre appareil. Sinon, <a href="/pages/demander-un-devis?source=recherche-sans-resultat">envoyez-nous la référence ou une photo</a> : on la cherche pour vous.';
      return `
        <li class="kFunnel__productItem kFunnel__productItem--empty">
          <div class="kFunnel__empty">
            <p class="kFunnel__emptyTitle">${title}</p>
            <p class="kFunnel__emptyText">${text}</p>
            <div class="kFunnel__emptyActions">
              <a class="kFunnel__emptyButton" href="/pages/trouver-ma-piece">Choisir ma marque et mon modèle</a>
              <a class="kFunnel__emptyButton kFunnel__emptyButton--secondary" href="/pages/symptomes-diagnostics">Partir d’un symptôme</a>
            </div>
          </div>
        </li>`;
    };

    const fetchCollectionProducts = async (handle) => {
      if (collectionCache.has(handle)) return collectionCache.get(handle);
      const products = [];
      for (let page = 1; page <= 6; page += 1) {
        const response = await fetchWithTimeout(`/collections/${handle}/products.json?limit=250&page=${page}`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error(`Cannot load products for ${handle}`);
        const payload = await response.json();
        const batch = payload.products || [];
        products.push(...batch);
        if (batch.length < 250) break;
      }
      collectionCache.set(handle, products);
      return products;
    };

    const scopedQuery = (state) => {
      const parts = ['poele bois'];
      if (state.brand) parts.push(state.brand);
      if (state.model) parts.push(state.model);
      return parts.join(' ');
    };

    const updateCategoryLinks = (state) => {
      const base = scopedQuery(state);
      root.querySelectorAll('[data-k-filter-group="categories"] .kFunnel__filterLink').forEach((link) => {
        const category = link.getAttribute('data-k-category');
        if (!category) return;
        link.setAttribute('href', setLinkQuery(link.getAttribute('href') || window.location.pathname, `${base} ${categoryQueryWords[category]}`));
      });
    };

    const updateActiveLinks = (state) => {
      root.querySelectorAll('[data-k-brand-models]').forEach((group) => {
        group.hidden = group.getAttribute('data-k-brand-models') !== state.brandHandle;
      });
      root.querySelectorAll('.kFunnel__filterLink').forEach((link) => {
        link.classList.remove('is-active');
        const ownHandle = link.getAttribute('data-k-handle');
        if (ownHandle) {
          if (ownHandle === state.modelHandle || (ownHandle === state.brandHandle && !link.closest('[data-k-brand-models]'))) link.classList.add('is-active');
          return;
        }
        const href = link.getAttribute('href') || '';
        const linkQuery = normalize(new URL(href, window.location.origin).searchParams.get('q') || '');
        if (!linkQuery) return;
        const words = linkQuery.split(' ').filter(Boolean);
        if (words.length && words.every((word) => state.query.includes(word))) {
          link.classList.add('is-active');
        }
      });
    };

    const clearCategoryCounts = () => {
      root.querySelectorAll('[data-k-filter-group="categories"] .kFunnel__filterCount').forEach((count) => {
        count.textContent = '';
      });
    };

    const showPendingState = (state) => {
      updateCategoryLinks(state);
      updateActiveLinks(state);
      updateCopy(state, Number((countNode?.textContent || '').match(/\d+/)?.[0] || 0));
      root.querySelectorAll('[data-k-filter-group="categories"] .kFunnel__filterCount').forEach((count) => {
        count.textContent = '...';
      });
      if (countNode) countNode.textContent = 'Chargement...';
      if (grid) grid.setAttribute('aria-busy', 'true');
      serverPaginationWrappers.forEach((pagination) => {
        pagination.hidden = true;
        pagination.setAttribute('aria-hidden', 'true');
      });
    };

    const countProductsForCategory = async (state, sourceProducts, category) => {
      const scopedState = {
        ...state,
        category,
        categoryLabel: categoryLabels[category] || '',
        usesFamilyCollection: false,
      };

      if (state.modelHandle || state.brandHandle) {
        return sourceProducts.filter((product) => productMatches(product, scopedState)).length;
      }

      const sectorProducts = state.collectionHandle === 'sector-poeles-a-bois'
        ? sourceProducts
        : await fetchCollectionProducts('sector-poeles-a-bois');
      return sectorProducts.filter((product) => productMatches(product, scopedState)).length;
    };

    const updateCategoryCounts = async (state, sourceProducts) => {
      const counts = {};
      await Promise.all(Object.keys(categoryLabels).map(async (category) => {
        counts[category] = await countProductsForCategory(state, sourceProducts, category);
      }));

      root.querySelectorAll('[data-k-filter-group="categories"] .kFunnel__filterLink').forEach((link) => {
        const category = link.getAttribute('data-k-category');
        const count = link.querySelector('.kFunnel__filterCount');
        if (category && count) count.textContent = String(counts[category] ?? 0);
      });
    };

    const updateCopy = (state, visibleCount) => {
      if (titleNode) {
        if (state.dimensionQuery && state.rawQuery) {
          titleNode.textContent = `Recherche par taille : ${state.rawQuery}`;
        } else if (state.technicalReference && state.rawQuery) {
          titleNode.textContent = `Référence ${state.rawQuery}`;
        } else if (!state.query) {
          titleNode.textContent = 'Toutes les pièces détachées';
        } else if (state.freeTextLabel && state.modelLabel) {
          titleNode.textContent = `Résultats ${state.freeTextLabel} - ${state.modelLabel}`;
        } else if (state.freeTextLabel && state.brandLabel) {
          titleNode.textContent = `Résultats ${state.freeTextLabel} - ${state.brandLabel}`;
        } else if (!state.device && !state.brand && !state.model && !state.category) {
          titleNode.textContent = 'Recherche par référence ou mot-clé';
        } else if (state.category && state.modelLabel) {
          titleNode.textContent = `${state.categoryLabel} compatibles ${state.modelLabel}`;
        } else if (state.category && state.brandLabel) {
          titleNode.textContent = `${state.categoryLabel} ${state.brandLabel}`;
        } else if (state.modelLabel) {
          titleNode.textContent = `Toutes les pièces compatibles avec ${state.modelLabel}`;
        } else if (state.brandLabel) {
          titleNode.textContent = state.brandLabel;
        } else if (state.categoryLabel) {
          titleNode.textContent = state.categoryLabel;
        } else if (state.deviceLabel) {
          titleNode.textContent = state.deviceLabel;
        }
      }

      if (metaNode) {
        metaNode.textContent = state.dimensionQuery
          ? 'Recherche de dimensions normalisée en millimètres : mm/cm, Ø, filetage MxL, formats 2D/3D et virgules décimales.'
          : state.technicalReference
          ? 'Recherche exacte de référence du fabricant, sans tenir compte des espaces, tirets, points, barres ni de la casse.'
          : state.freeTextLabel && (state.modelLabel || state.brandLabel)
          ? 'Recherche affinée dans votre sélection. Vérifiez le modèle exact avant achat.'
          : state.query
          ? 'Pièces compatibles avec votre sélection. Vérifiez le modèle exact avant achat.'
          : state.modelLabel
          ? `Toutes les pièces documentées compatibles avec ${state.modelLabel}. Affinez par type de pièce si nécessaire.`
          : 'Affinez par marque, modèle puis catégorie.';
      }

      const labels = [state.brandLabel, state.modelLabel, state.categoryLabel].filter(Boolean);

      if (chipsNode) {
        chipsNode.innerHTML = labels.length
          ? labels.map((label) => `<span class="kFunnel__chip">${escapeHtml(label)}</span>`).join('')
          : '';
      }

      if (activeSummaryNode) {
        activeSummaryNode.textContent = labels.length ? labels.join(' > ') : 'Tout le catalogue';
      }

      if (countNode) countNode.textContent = `${visibleCount} produit${visibleCount > 1 ? 's' : ''}`;
    };

    const fetchWithTimeout = async (url, options = {}, timeoutMs = 9000) => {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), timeoutMs);
      try {
        return await fetch(url, { ...options, signal: controller.signal });
      } finally {
        window.clearTimeout(timeout);
      }
    };

    const restoreServerFallback = () => {
      root.querySelectorAll('.kFunnel__productItem').forEach((item) => { item.hidden = false; });
      clearCategoryCounts();
      if (grid) grid.setAttribute('aria-busy', 'false');
      const visibleProducts = [...root.querySelectorAll('.kFunnel__productItem:not(.kFunnel__productItem--empty)')]
        .filter((item) => {
          const style = window.getComputedStyle(item);
          return !item.hidden && style.display !== 'none' && style.visibility !== 'hidden';
        }).length;
      if (countNode) countNode.textContent = `${visibleProducts} produit${visibleProducts > 1 ? 's' : ''}`;
      if (metaNode && /chargement/i.test(metaNode.textContent || '')) {
        metaNode.textContent = 'Affinez par marque, modèle puis catégorie.';
      }
      serverPaginationWrappers.forEach((pagination) => {
        pagination.hidden = false;
        pagination.setAttribute('aria-hidden', 'false');
      });
    };

    const enrichStateFromCatalog = async (state) => {
      if (state.technicalReference || state.dimensionQuery || !state.rawQuery) return state;
      if (!window.KrepiteSearch?.resolveCatalogContext) return state;

      const context = await window.KrepiteSearch.resolveCatalogContext(state.rawQuery);
      if (!context || !context.type) return state;

      if (context.type === 'model' && context.model_handle) {
        state.model = context.model_query || normalize(context.model_label || '');
        state.modelLabel = context.model_label || '';
        state.modelHandle = context.model_handle;
        state.brand = context.brand || '';
        state.brandLabel = context.brand_label || '';
        state.brandHandle = context.brand_handle || '';
        state.device = 'bois';
        state.deviceLabel = 'Poêle à bois';
      } else if (context.type === 'brand' && context.brand_handle && !state.modelHandle) {
        state.brand = context.brand || '';
        state.brandLabel = context.brand_label || '';
        state.brandHandle = context.brand_handle;
      }

      state.freeTextGroups = buildFreeTextGroups(state.query, state);
      state.freeTextLabel = state.freeTextGroups.map((group) => group[0]).join(' ');

      if (state.modelHandle) {
        state.collectionHandle = state.modelHandle;
      } else if (state.brandHandle) {
        state.collectionHandle = state.brandHandle;
      }
      return state;
    };

    // ---------- Page de resultats (31/10) ----------
    // Avec une requete q : ligne de contexte, puces des types presents, « Pour quel
    // appareil ? », groupes par sous-famille. Marques, modeles, familles et sous-familles
    // sont lus dans les donnees (finder-data, catalogue, familles_json, k-sous-familles.json).
    const resContexte = root.querySelector('[data-k-res-contexte]');
    const resTypes = root.querySelector('[data-k-res-types]');
    const resAppareil = root.querySelector('[data-k-res-appareil]');
    const resEtat = root.querySelector('[data-k-res-etat]');
    const resEtatInitial = resEtat ? resEtat.innerHTML : '';
    const resGroupes = root.querySelector('[data-k-res-groupes]');
    let resDernier = null;
    let resType = '';
    let resMontres = {};
    let resAppareilAuto = false;
    let resNote = '';
    let resFocusApres = '';

    const modeResultats = () => Boolean(cleanSearchQuery(new URLSearchParams(window.location.search).get('q') || ''));
    const syncModeResultats = () => {
      const actif = modeResultats();
      root.classList.toggle('kFunnel--resultats', actif);
      root.setAttribute('aria-labelledby', actif ? 'kRes-contexte' : 'kFunnel-title');
      return actif;
    };
    const nPieces = (n) => `${n} pièce${n > 1 ? 's' : ''}`;
    const slugRes = (texte) => normalize(texte).replace(/ /g, '-') || 'autres';
    const libelleCategorie = (cle) => {
      const item = (smartFinderData?.categories || []).find((c) => String(c.handle || '') === String(cle || ''));
      return item ? String(item.label || item.handle || '') : '';
    };
    const libelleMarque = (handle) => {
      const item = (smartFinderData?.brands || []).find((b) => String(b.handle || '') === String(handle || ''));
      return item ? String(item.label || handle) : String(handle || '');
    };
    const libelleModele = (handle) => String(smartFinderData?.models?.[handle]?.model_label || handle || '');
    const modeleCourt = (label, marque) => {
      const l = String(label || '').trim();
      const m = String(marque || '').trim();
      return m && normalize(l).startsWith(`${normalize(m)} `) && l.length > m.length ? l.slice(m.length).trim() : l;
    };
    // Marques d'APPAREILS : celles qui ont au moins un modele dans les donnees du Finder.
    // Un fabricant de conduits (sans modele d'appareil) n'est pas un appareil ; ses pieces
    // restent accessibles par leur type (puces) et par le tiroir de filtres.
    let resMarquesAppareils = null;
    const marquesAppareils = () => {
      if (!resMarquesAppareils) {
        resMarquesAppareils = new Set(Object.values(smartFinderData?.models || {}).map((m) => String(m?.brand || '')).filter(Boolean));
      }
      return resMarquesAppareils;
    };
    const donneesDisponibles = () => Object.keys(smartFinderData?.models || {}).length > 0 || (smartFinderData?.catalogParts || []).length > 0;

    // Modeles d'une fiche : toutes les vues eclatees qui la portent (cle canonique).
    let resModelesParCle = null;
    function modelesDeLaPiece(part) {
      if (!resModelesParCle) {
        resModelesParCle = new Map();
        Object.entries(smartFinderData?.models || {}).forEach(([handle, model]) => {
          (model?.candidate_parts || []).forEach((piece) => {
            const cle = String(piece.canonical_key || piece.product_handle || '');
            if (!cle) return;
            if (!resModelesParCle.has(cle)) resModelesParCle.set(cle, new Set());
            resModelesParCle.get(cle).add(handle);
          });
        });
      }
      const cle = String(part?.canonical_key || part?.product_handle || '');
      const modeles = cle ? resModelesParCle.get(cle) : null;
      const liste = modeles ? [...modeles] : [];
      const propre = String(part?.model_handle || '');
      if (propre && !liste.includes(propre)) liste.push(propre);
      return liste;
    }
    function marquesDeLaPiece(part) {
      const marques = new Set(modelesDeLaPiece(part).map((h) => String(smartFinderData?.models?.[h]?.brand || '')).filter(Boolean));
      if (part?.brand_handle) marques.add(String(part.brand_handle));
      return [...marques];
    }

    // Regroupement (k-search-groupes.js) : le contrat du pipeline (`famille`, `sous_famille`
    // sur chaque piece, libelles dans `familles` de l'index) fait foi ; en son absence, repli
    // par les termes de la taxonomie (k-sous-familles.json) lus dans le titre.
    let sousFamillesPromise = null;
    const chargerSousFamilles = () => {
      if (sousFamillesPromise) return sousFamillesPromise;
      const url = root.getAttribute('data-k-sous-familles-url') || '';
      sousFamillesPromise = (url ? fetch(url, { credentials: 'same-origin' }).then((r) => (r.ok ? r.json() : null)) : Promise.resolve(null))
        .catch(() => null);
      return sousFamillesPromise;
    };
    const grouperResultats = (products, sousFamillesBrutes, familleDemandee = '') => {
      const moteur = window.KrepiteSearchGroupes;
      if (!moteur) return products.length ? [{ cle: 'pieces', label: 'Pièces', reste: false, detail: false, items: products }] : [];
      return moteur.grouper(products, {
        familles: moteur.preparerFamilles(funnelCatalogue.familles || []),
        sousFamilles: moteur.preparerSousFamilles(sousFamillesBrutes),
        libellesContrat: smartFinderData?.famillesContrat || {},
        familleDemandee,
      });
    };

    const memoriserAppareil = (modelHandle) => {
      const model = smartFinderData?.models?.[modelHandle];
      if (!model || !window.KrepiteDeviceMemory?.set) return;
      const marque = String(model.brand || '');
      window.KrepiteDeviceMemory.set({
        model_handle: modelHandle,
        brand_handle: marque,
        brand_label: libelleMarque(marque),
        model_label: String(model.model_label || modelHandle),
        variant: null,
      }, 'recherche');
    };

    // Appareil memorise : applique au chargement d'une recherche sans marque ni modele.
    const appliquerAppareilMemorise = () => {
      resAppareilAuto = false;
      const url = new URL(window.location.href);
      const requete = cleanSearchQuery(url.searchParams.get('q') || '');
      if (!requete || url.searchParams.get('brand') || url.searchParams.get('model') || url.searchParams.get('appareil') === 'tous') return;
      const memoire = window.KrepiteDeviceMemory?.get?.();
      if (!memoire) return;
      const modelHandle = String(memoire.model_handle || '').replace(/^model-/, '');
      const model = smartFinderData?.models?.[modelHandle];
      if (!model) return;
      const essai = buildState(requete);
      if (essai.brandHandle || essai.modelHandle || essai.technicalReference || essai.dimensionQuery) return;
      url.searchParams.set('brand', String(model.brand || memoire.brand_handle || ''));
      url.searchParams.set('model', modelHandle);
      window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      resAppareilAuto = true;
    };

    const appliquerAppareil = ({ brand = '', model = '', partout = false } = {}) => {
      resAppareilAuto = false;
      resNote = '';
      if (smartBrand) smartBrand.value = brand;
      refreshSmartModels(model);
      if (smartModel) smartModel.value = model;
      applySmartFilters({ appareil: partout ? 'tous' : null });
    };

    // 01/11 (decision Florian) : delai de reponse lu dans les donnees boutique (custom.delai_reponse).
    // Delai de reponse : metachamp boutique, pose sur la section par le gabarit (data-delai-reponse).
    const DELAI_REPONSE = root.dataset.delaiReponse || '';
    const resVide = (state) => {
      const technique = Boolean(state?.technicalReference && state?.rawQuery);
      const dimension = Boolean(state?.dimensionQuery && state?.rawQuery);
      const cadre = Boolean(smartParams().model || smartParams().brand);
      const titre = dimension
        ? 'Aucune pièce avec cette taille documentée'
        : technique
        ? 'Référence introuvable dans le catalogue en ligne'
        : cadre
        ? 'Aucune pièce pour cet appareil'
        : 'On la cherche pour vous';
      const texte = dimension
        ? 'Les formats mm/cm, Ø, M6x20, 420x310 et les décimales avec virgule sont reconnus. Vérifiez la mesure, ou envoyez-la-nous : on la cherche pour vous.'
        : technique
        ? 'Les espaces, tirets, points et barres sont déjà ignorés. Vérifiez la référence sur votre pièce, ou envoyez-la-nous : on la cherche pour vous.'
        : cadre
        ? 'Cette recherche ne donne aucune pièce documentée pour l’appareil choisi. Cherchez sur tous les appareils, ou envoyez-nous la référence : on la cherche pour vous.'
        : 'Envoyez-nous la référence ou une photo : une vraie personne la cherche pour vous' + (DELAI_REPONSE ? ' et vous répond ' + DELAI_REPONSE : '') + '. Vous pouvez aussi essayer le nom de la pièce (joint, vitre, grille…).';
      return `
        <div class="kRes__vide">
          <h2 class="k-t3">${titre}</h2>
          <p>${texte}</p>
          <div class="kRes__videActions">
            ${cadre ? '<button class="k-b2" type="button" data-k-res-partout>Chercher partout</button>' : ''}
            <a class="k-b1" href="${escapeHtml(withPreview(`/pages/demander-un-devis?source=recherche-sans-resultat&q=${encodeURIComponent(String(state?.rawQuery || '').slice(0, 200))}`))}">Envoyer ma recherche</a>
            ${cadre ? '' : `<a class="k-b2" href="${escapeHtml(withPreview('/pages/trouver-ma-piece'))}">Choisir mon modèle</a>`}
          </div>
        </div>`;
    };

    const resEnAttente = (state) => {
      if (!resDernier) {
        if (resContexte) resContexte.textContent = `Recherche de « ${state.rawQuery} »…`;
        if (resEtat) { resEtat.innerHTML = resEtatInitial; resEtat.hidden = false; }
      }
      resGroupes?.setAttribute('aria-busy', 'true');
    };

    const resErreur = () => {
      resDernier = null;
      resNombre = null;
      if (resContexte) resContexte.textContent = 'Le catalogue met du temps à répondre';
      if (resEtat) {
        resEtat.hidden = false;
        resEtat.innerHTML = '<p class="kRes__etatTexte">Le catalogue n’a pas pu être chargé. Vérifiez votre connexion, puis réessayez.</p><button class="k-b2" type="button" data-k-res-reessayer>Réessayer</button>';
      }
      if (resGroupes) { resGroupes.innerHTML = ''; resGroupes.setAttribute('aria-busy', 'false'); }
      if (resTypes) resTypes.innerHTML = '';
      if (resAppareil) resAppareil.hidden = true;
    };

    // 01/11 (audit 30 profils, P1) : sans piece, les MEMES pistes que la liste de suggestions
    // (panne, famille, modele, marque), venues de KrepiteLiveSearch.pistes : « mon poele fume »
    // mene a « Mon feu tire mal ou refoule » au lieu d'un « Aucune piece » sec.
    const resPistes = async (state) => {
      if (!window.KrepiteLiveSearch?.pistes || !resGroupes) return;
      const pistes = await window.KrepiteLiveSearch.pistes(state.rawQuery);
      const vide = resGroupes.querySelector('.kRes__vide');
      if (!pistes.length || !vide || vide.querySelector('.kRes__pistes')) return;
      const liste = `<div class="kRes__pistes"><p class="kRes__pistesTitre">Ce qui correspond à votre recherche</p><ul role="list">${pistes.map((p) => `<li><a class="k-b3" href="${escapeHtml(withPreview(p.url))}">${escapeHtml(p.title)}</a>${p.meta ? ` <span class="kRes__pistesMeta">${escapeHtml(p.meta)}</span>` : ''}</li>`).join('')}</ul></div>`;
      const actions = vide.querySelector('.kRes__videActions');
      if (actions) actions.insertAdjacentHTML('beforebegin', liste); else vide.insertAdjacentHTML('beforeend', liste);
    };

    const resRendre = () => {
      if (!resDernier || !resGroupes) return;
      const { state, groupes } = resDernier;
      const visibles = resType ? groupes.filter((g) => g.cle === resType) : groupes;
      const total = visibles.reduce((somme, g) => somme + g.items.length, 0);
      resNombre = total;
      if (resContexte) resContexte.textContent = total ? `${nPieces(total)} pour « ${state.rawQuery} »` : `« ${state.rawQuery} » : on la cherche pour vous`;
      if (resTypes) {
        resTypes.innerHTML = groupes.length > 1
          ? groupes.map((g) => `<button class="k-puce kRes__puce${g.cle === resType ? ' k-puce--active' : ''}" type="button" data-k-res-type="${escapeHtml(g.cle)}" aria-pressed="${g.cle === resType}">${escapeHtml(g.label)} <span class="kRes__nb">${g.items.length}</span></button>`).join('')
          : '';
      }
      if (resEtat) resEtat.hidden = true;
      resGroupes.setAttribute('aria-busy', 'false');
      if (!total) {
        resGroupes.innerHTML = resVide(state);
        syncSmartDrawerCount();
        resPistes(state);
        return;
      }
      const seul = visibles.length === 1;
      const limite = seul ? 48 : (window.matchMedia('(min-width: 990px)').matches ? 10 : 6);
      resGroupes.innerHTML = visibles.map((g) => {
        const montres = Math.max(limite, resMontres[g.cle] || 0);
        const reste = g.items.length - montres;
        const id = `kRes-g-${g.cle}`;
        const suite = reste <= 0 ? '' : seul
          ? `<p class="kRes__suite"><button class="k-b2" type="button" data-k-res-plus="${escapeHtml(g.cle)}">Voir plus (${nPieces(reste)})</button></p>`
          : `<p class="kRes__suite"><button class="k-b2" type="button" data-k-res-type="${escapeHtml(g.cle)}" aria-label="Voir tout (${g.items.length}) : ${escapeHtml(g.label)}">Voir tout (${g.items.length})</button></p>`;
        return `<section class="kRes__groupe" aria-labelledby="${id}">
            <h2 class="k-t3 kRes__groupeTitre" id="${id}">${escapeHtml(g.label)} <span class="kRes__nb">${g.items.length}</span></h2>
            <ul class="kRes__grille" role="list">${g.items.slice(0, montres).map(renderCard).join('')}</ul>
            ${suite}
          </section>`;
      }).join('');
      hydrateSchemaCrops(resGroupes);
      hydrateLazyPhotos(resGroupes);
      syncSmartDrawerCount();
    };

    const resRendreAppareil = () => {
      if (!resAppareil || !resDernier) return;
      const { state, source } = resDernier;
      if (state.technicalReference || state.dimensionQuery) { resAppareil.hidden = true; return; }
      const choisi = smartParams();
      const modelHandle = String(state.modelHandle || '').replace(/^model-/, '');
      const brandHandle = String(state.brandHandle || '').replace(/^brand-/, '');
      const note = resNote ? `<p class="kRes__appareilAide">${escapeHtml(resNote)}</p>` : '';
      resAppareil.classList.toggle('kRes__appareil--choisi', Boolean(modelHandle));
      if (modelHandle) {
        const label = libelleModele(modelHandle) || state.modelLabel;
        const actions = choisi.model
          ? '<span class="kRes__appareilActions"><button class="k-b3" type="button" data-k-res-partout>Chercher partout</button><button class="k-b3" type="button" data-k-res-changer aria-label="Changer d’appareil">Changer</button><button class="k-b3" type="button" data-k-res-oublier aria-label="Oublier cet appareil">Oublier</button></span>'
          : '';
        // 01/11 (lot P1) : memes libelles que le bandeau « Mon appareil » de toutes les pages.
        // 04/11 (critique Impeccable) : quand l'appareil filtre les resultats (choisi ou memorise), on le DIT au client,
        // avec « Chercher partout » juste a cote.
        const filtre = Boolean(choisi.model);
        resAppareil.innerHTML = `<h2 class="visually-hidden" id="kRes-appareil-titre">Votre appareil</h2><p class="kRes__appareilLigne"><span class="kRes__appareilNom">${filtre ? 'Résultats limités à votre appareil' : 'Votre appareil'} : <strong>${escapeHtml(label)}</strong></span>${actions}</p>`;
        resAppareil.hidden = false;
      } else {
        // Marques et modeles PRESENTS dans les resultats, sans doublon de fiche.
        const parMarque = new Map();
        const parModele = new Map();
        const vus = new Set();
        (source || []).forEach((part) => {
          const fiche = String(part.url || part.canonical_key || part.product_handle || part.reference_oem || '');
          if (!fiche) return;
          marquesDeLaPiece(part).forEach((b) => {
            if (!marquesAppareils().has(b)) return;
            if (vus.has(`b|${b}|${fiche}`)) return;
            vus.add(`b|${b}|${fiche}`);
            parMarque.set(b, (parMarque.get(b) || 0) + 1);
          });
          modelesDeLaPiece(part).forEach((m) => {
            if (vus.has(`m|${m}|${fiche}`)) return;
            vus.add(`m|${m}|${fiche}`);
            parModele.set(m, (parModele.get(m) || 0) + 1);
          });
        });
        if (!parMarque.size) {
          resAppareil.hidden = true;
        } else {
          let html = `<h2 class="k-t3 kRes__appareilTitre" id="kRes-appareil-titre">Pour quel appareil ?</h2>${note}`;
          if (!brandHandle) {
            const marques = [...parMarque.entries()].sort((a, b) => (b[1] - a[1]) || libelleMarque(a[0]).localeCompare(libelleMarque(b[0]), 'fr'));
            html += '<p class="kRes__appareilAide">Choisissez votre marque, puis votre modèle.</p>';
            html += '<div class="kRes__puces" role="group" aria-label="Marques présentes dans les résultats">'
              + marques.slice(0, 12).map(([h, n]) => `<button class="k-puce kRes__puce" type="button" data-k-res-marque="${escapeHtml(h)}" aria-pressed="false">${escapeHtml(libelleMarque(h))} <span class="kRes__nb">${n}</span></button>`).join('')
              + (marques.length > 12 ? `<button class="k-puce kRes__puce" type="button" data-k-res-ouvrir="brand">Autres marques <span class="kRes__nb">${marques.length - 12}</span></button>` : '')
              + '</div>';
          } else {
            const marqueLabel = libelleMarque(brandHandle);
            const modeles = [...parModele.entries()]
              .filter(([m]) => String(smartFinderData?.models?.[m]?.brand || '') === brandHandle)
              .sort((a, b) => (b[1] - a[1]) || libelleModele(a[0]).localeCompare(libelleModele(b[0]), 'fr', { numeric: true }));
            // Au-dela de 12 modeles, le champ de recherche vient en premier, avant la liste.
            if (modeles.length > 12) {
              html += `<label class="kRes__filtreModeles"><span class="visually-hidden">Rechercher un modèle ${escapeHtml(marqueLabel)}</span><input type="text" inputmode="search" autocomplete="off" spellcheck="false" placeholder="Rechercher un modèle ${escapeHtml(marqueLabel)}" data-k-res-filtre-modeles></label>`;
            } else {
              html += `<p class="kRes__appareilAide">${modeles.length ? `Puis votre modèle ${escapeHtml(marqueLabel)} :` : `Aucun modèle ${escapeHtml(marqueLabel)} documenté dans ces résultats.`}</p>`;
            }
            html += '<div class="kRes__puces" role="group" aria-label="Marque et modèles">'
              + `<button class="k-puce k-puce--active kRes__puce" type="button" data-k-res-marque="" aria-pressed="true" aria-label="Retirer la marque ${escapeHtml(marqueLabel)}">${escapeHtml(marqueLabel)}<svg viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 3l6 6M9 3 3 9"/></svg></button>`
              + modeles.map(([m, n]) => `<button class="k-puce kRes__puce" type="button" data-k-res-modele="${escapeHtml(m)}" data-k-res-nom="${escapeHtml(normalize(libelleModele(m)))}" aria-pressed="false">${escapeHtml(modeleCourt(libelleModele(m), marqueLabel))} <span class="kRes__nb">${n}</span></button>`).join('')
              + '</div>';
          }
          resAppareil.innerHTML = html;
          resAppareil.hidden = false;
        }
      }
      if (resFocusApres) {
        const cible = resAppareil.querySelector(resFocusApres) || resAppareil.querySelector('button');
        resFocusApres = '';
        cible?.focus?.({ preventScroll: true });
      }
    };

    const resAfficher = async (state, products, source) => {
      const sousFamilles = await chargerSousFamilles();
      const groupes = grouperResultats(products, sousFamilles, state.category || '');
      const typeUrl = new URLSearchParams(window.location.search).get('type') || '';
      resDernier = { state, products, source, groupes };
      resMontres = {};
      resType = groupes.some((g) => g.cle === typeUrl) ? typeUrl : '';
      resRendre();
      resRendreAppareil();
    };

    const resChoisirType = (cle, defiler = false) => {
      resType = resType === cle ? '' : cle;
      const url = new URL(window.location.href);
      if (resType) url.searchParams.set('type', resType); else url.searchParams.delete('type');
      window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      resRendre();
      const puce = resTypes?.querySelector(`[data-k-res-type="${CSS.escape(resType || cle)}"]`);
      puce?.focus?.({ preventScroll: true });
      // 03/11 (lot des ancres) : plus de defilement force ; apres « Voir tout », le focus passe au debut des resultats
      // (le navigateur ne fait defiler que si ce debut est hors de l'ecran).
      if (defiler && resContexte) {
        if (!resContexte.hasAttribute('tabindex')) resContexte.setAttribute('tabindex', '-1');
        resContexte.focus();
      }
    };

    root.querySelector('[data-k-res]')?.addEventListener('click', (event) => {
      const cible = event.target instanceof Element ? event.target.closest('button') : null;
      if (!cible || !root.contains(cible)) return;
      if (cible.hasAttribute('data-k-res-type')) { resChoisirType(cible.getAttribute('data-k-res-type') || '', cible.closest('.kRes__suite') !== null); return; }
      if (cible.hasAttribute('data-k-res-plus')) {
        const cle = cible.getAttribute('data-k-res-plus') || '';
        const groupe = resDernier?.groupes.find((g) => g.cle === cle);
        resMontres[cle] = Math.max(48, resMontres[cle] || 0) + 48;
        resRendre();
        if (groupe) resGroupes?.querySelectorAll('.kRes__grille > li')[Math.max(0, resMontres[cle] - 48)]?.querySelector('a')?.focus?.({ preventScroll: true });
        return;
      }
      if (cible.hasAttribute('data-k-res-marque')) {
        const marque = cible.getAttribute('data-k-res-marque') || '';
        resFocusApres = marque ? '[data-k-res-modele]' : '[data-k-res-marque]';
        appliquerAppareil(marque ? { brand: marque } : { partout: true });
        return;
      }
      if (cible.hasAttribute('data-k-res-modele')) {
        const modele = cible.getAttribute('data-k-res-modele') || '';
        const marque = String(smartFinderData?.models?.[modele]?.brand || '');
        resFocusApres = '[data-k-res-partout]';
        memoriserAppareil(modele);
        appliquerAppareil({ brand: marque, model: modele });
        return;
      }
      if (cible.hasAttribute('data-k-res-partout')) { resFocusApres = '[data-k-res-marque]'; appliquerAppareil({ partout: true }); return; }
      if (cible.hasAttribute('data-k-res-oublier')) {
        try { window.KrepiteDeviceMemory?.clear(); } catch (e) { /* stockage indisponible */ }
        resFocusApres = '[data-k-res-marque]';
        appliquerAppareil({ partout: true });
        return;
      }
      if (cible.hasAttribute('data-k-res-changer')) {
        const marque = String(smartParams().brand || '');
        resFocusApres = '[data-k-res-modele]';
        appliquerAppareil(marque ? { brand: marque, partout: true } : { partout: true });
        return;
      }
      if (cible.hasAttribute('data-k-res-ouvrir')) { openSmartDrawer(cible.getAttribute('data-k-res-ouvrir') || 'all'); return; }
      if (cible.hasAttribute('data-k-res-reessayer')) window.location.reload();
    });

    resAppareil?.addEventListener('input', (event) => {
      const champ = event.target instanceof Element ? event.target.closest('[data-k-res-filtre-modeles]') : null;
      if (!champ) return;
      const filtre = normalize(champ.value);
      resAppareil.querySelectorAll('[data-k-res-modele]').forEach((puce) => {
        puce.hidden = Boolean(filtre) && !String(puce.getAttribute('data-k-res-nom') || '').includes(filtre);
      });
    });

    const applyState = async (rawQuery) => {
      const runId = ++applyRunId;
      const state = await applySmartState(await enrichStateFromCatalog(buildState(rawQuery)));
      if (runId !== applyRunId) return;
      if (searchInput) searchInput.value = state.rawQuery;

      showPendingState(state);
      if (modeResultats()) resEnAttente(state);

      const activeGrid = ensureProductsGrid();
      if (activeGrid) {
        const engineReady = Boolean(window.KrepiteSearch);
        const sourceProducts = engineReady ? [] : await fetchCollectionProducts(state.collectionHandle);
        if (runId !== applyRunId) return;

        let canonicalOemMatches = [];
        let canonicalDimensionMatches = [];
        let canonicalTextMatches = [];
        if (state.technicalReference && window.KrepiteSearch?.lookupExactOem) {
          canonicalOemMatches = await window.KrepiteSearch.lookupExactOem(state.rawQuery);
          if (runId !== applyRunId) return;
        }
        if (state.dimensionQuery && window.KrepiteSearch?.lookupDimensions) {
          canonicalDimensionMatches = await window.KrepiteSearch.lookupDimensions(state.dimensionQuery, 250);
          if (runId !== applyRunId) return;
        }
        if (!state.technicalReference && !state.dimensionQuery && engineReady) {
          canonicalTextMatches = await smartMatches(state.rawQuery, state);
          if (runId !== applyRunId) return;
        }
        // 01/11 (audit 30 profils, P1) : Entree = la liste de suggestions. Rien d'exact
        // (« 1358 », « PV19 », « AA035 ») : meme moteur que la liste (lookupLive), qui
        // trouve les references partielles ; jamais un « introuvable » quand la liste trouvait.
        if (!canonicalOemMatches.length && !canonicalDimensionMatches.length && !canonicalTextMatches.length && window.KrepiteSearch?.lookupLive) {
          canonicalTextMatches = (await window.KrepiteSearch.lookupLive(state.rawQuery, 60, null)).filter((item) => item && item.kind === 'part');
          if (runId !== applyRunId) return;
        }

        const canonicalProducts = canonicalOemMatches.concat(canonicalDimensionMatches, canonicalTextMatches).map((part) => ({
          handle: part.product_handle || '',
          title: part.title || part.reference_oem,
          variants: [{ sku: part.reference_oem || '' }],
          _url: part.url || (part.product_handle ? '/products/' + part.product_handle : ''),
          product_type: part.category || '',
          vendor: part.brand_handle || '',
          _previewImage: part.product_preview?.image || null,
          _schemaImage: part.schema_image_filename || '',
          _schemaDims: [Number(part.schema_image_width_px) || 0, Number(part.schema_image_height_px) || 0],
          _highlight: part.highlight || null,
          _repere: part.repere || '',
          _modelLabel: part.model_label || '',
          _modelHandle: part.model_handle || '',
          _brandHandle: part.brand_handle || '',
          _categoryLabel: part.category_label || libelleCategorie(part.category),
          _commerce: window.KrepiteSearch?.commerceDisplay ? window.KrepiteSearch.commerceDisplay(part) : null,
          // Contrat du pipeline : champ absent = repli par le titre ; sous_famille null = « Autres ».
          _famille: part.famille || undefined,
          _sousFamille: Object.prototype.hasOwnProperty.call(part, 'sous_famille') ? part.sous_famille : undefined,
          // Fiche sans vue eclatee (accessoire, fumisterie) : sa photo est
          // celle de la fiche Shopify, chargee quand la carte devient visible.
          _standalone: !part.model_handle,
        }));
        const collectionProducts = engineReady ? [] : sourceProducts.filter((product) => productMatches(product, state));
        const seenProducts = new Set();
        const visibleProducts = canonicalProducts.concat(collectionProducts).filter((product) => {
          const referenceKey = normalizeOemValue(product.variants?.[0]?.sku || '');
          const brandKey = normalize(product.vendor || '').replace(/\s+/g, '');
          const id = (state.technicalReference || state.dimensionQuery) && referenceKey
            ? `${brandKey}:${referenceKey}`
            : (product._url || product.handle || referenceKey);
          if (!id || seenProducts.has(id)) return false;
          seenProducts.add(id);
          return true;
        });
        // Pieces d'usure d'abord, visserie en dernier (lot UX 2026-07-18) : le
        // premier ecran du catalogue neutre etait un mur de vis/rondelles alors
        // que les clients cherchent joints, vitres, deflecteurs. Tri stable :
        // l'ordre collection est conserve a priorite egale, et une recherche ou
        // un filtre actif n'est pas affecte (tous les resultats ont alors la
        // meme priorite ou l'utilisateur a demande la visserie explicitement).
        const WEAR_TYPES = ['joint', 'joints', 'vitre', 'vitrage', 'deflecteur', 'isolation', 'insulation', 'vermiculite', 'plaque', 'grille', 'poignee', 'porte', 'charniere', 'charnieres'];
        const FASTENER_TYPES = ['vis', 'visserie', 'rondelle', 'ecrou', 'boulon', 'goupille', 'bille'];
        const FASTENER_TITLE = /\b(vis|visserie|rondelle|ecrou|boulon|goupille)\b/;
        const partPriority = (product) => {
          const type = normalize(product.product_type || '');
          if (FASTENER_TYPES.includes(type)) return 2;
          if (WEAR_TYPES.includes(type)) return 0;
          if (FASTENER_TITLE.test(normalize(product.title || ''))) return 2;
          return 1;
        };
        if (!engineReady) {
          visibleProducts.sort((a, b) => {
            const prio = partPriority(a) - partPriority(b);
            if (prio !== 0) return prio;
            return 0;
          });
        }
        clearCategoryCounts();

        if (modeResultats()) {
          if (engineReady && !donneesDisponibles()) throw new Error('catalogue indisponible');
          const source = !state.technicalReference && !state.dimensionQuery && engineReady
            ? await smartMatches(state.rawQuery, state, { sansAppareil: true })
            : [];
          if (runId !== applyRunId) return;
          // Appareil memorise sans aucune piece pour cette recherche : on cherche partout.
          if (resAppareilAuto && !visibleProducts.length && source.length) {
            const label = libelleModele(String(state.modelHandle || '').replace(/^model-/, ''));
            appliquerAppareil({ partout: true });
            resNote = `Aucune pièce « ${state.rawQuery} » pour votre ${label} : voici celles de tous les appareils.`;
            return;
          }
          await resAfficher(state, visibleProducts, source);
          if (runId !== applyRunId) return;
          activeGrid.setAttribute('aria-busy', 'false');
          updateCopy(state, visibleProducts.length);
          updateActiveLinks(state);
          return;
        }

        const PAGE_SIZE = 48;
        let shown = 0;
        const renderPage = () => {
          const slice = visibleProducts.slice(shown, shown + PAGE_SIZE);
          if (shown === 0) {
            activeGrid.innerHTML = visibleProducts.length ? slice.map(renderCard).join('') : renderEmptyCard(state);
          } else {
            activeGrid.insertAdjacentHTML('beforeend', slice.map(renderCard).join(''));
          }
          hydrateSchemaCrops(activeGrid);
          hydrateLazyPhotos(activeGrid);
          shown += slice.length;
          const loadMore = root.querySelector('.kFunnel__loadMore');
          if (shown < visibleProducts.length) {
            if (loadMore) {
              loadMore.hidden = false;
              loadMore.querySelector('span').textContent = `Voir plus (${visibleProducts.length - shown} restants)`;
            } else {
              const btn = document.createElement('div');
              btn.className = 'kFunnel__loadMore';
              btn.innerHTML = '<button type="button" class="kFunnel__loadMoreBtn"><span>Voir plus (' + (visibleProducts.length - shown) + ' restants)</span></button>';
              btn.querySelector('button').addEventListener('click', renderPage);
              activeGrid.after(btn);
            }
          } else if (loadMore) {
            loadMore.hidden = true;
          }
        };
        renderPage();

        activeGrid.setAttribute('aria-busy', 'false');
        updateCopy(state, visibleProducts.length);
        syncSmartDrawerCount();
        serverPaginationWrappers.forEach((pagination) => {
          pagination.hidden = true;
          pagination.setAttribute('aria-hidden', 'true');
        });
      }

      updateActiveLinks(state);
    };

    const applyUrl = (url, replace = false) => {
      const nextUrl = new URL(url, window.location.href);
      const rawQuery = cleanSearchQuery(nextUrl.searchParams.get('q') || '');
      nextUrl.searchParams.delete('options');
      nextUrl.searchParams.set('view', 'trouver-piece-v3');
      if (rawQuery) nextUrl.searchParams.set('q', rawQuery);
      else nextUrl.searchParams.delete('q');
      const nextPath = `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
      if (replace) {
        window.history.replaceState({ kFunnelQuery: rawQuery }, '', nextPath);
      } else {
        window.history.pushState({ kFunnelQuery: rawQuery }, '', nextPath);
      }
      syncModeResultats();
      applyState(rawQuery).catch(() => {
        if (modeResultats()) resErreur(); else restoreServerFallback();
      });
    };

    root.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const link = target?.closest('a.kFunnel__filterLink, a.kFunnel__quickLink, a.kFunnel__reset');
      if (!link) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      const url = new URL(link.href, window.location.href);
      if (url.pathname !== window.location.pathname) return;
      event.preventDefault();
      if (link.matches('a.kFunnel__quickLink, a.kFunnel__reset')) {
        if (smartSector) smartSector.value = '';
        if (smartBrand) smartBrand.value = '';
        if (smartModel) smartModel.value = '';
        if (smartCategory) smartCategory.value = '';
        refreshSmartModels('');
      }
      applyUrl(url);
      if (window.matchMedia('(max-width: 989px)').matches) setFiltersOpen(false);
    });

    searchInput?.addEventListener('search', () => {
      if (searchInput.value) return;
      const url = new URL(window.location.href);
      url.searchParams.delete('q');
      url.searchParams.delete('page');
      applyUrl(url);
      updateSmartToolbar();
    });

    searchInput?.form?.addEventListener('submit', (event) => {
      event.preventDefault();
      if (smartSector) smartSector.value = '';
      if (smartBrand) smartBrand.value = '';
      if (smartModel) smartModel.value = '';
      if (smartCategory) smartCategory.value = '';
      refreshSmartModels('');
      const url = new URL(window.location.pathname, window.location.origin);
      const query = cleanSearchQuery(searchInput?.value || '');
      url.searchParams.set('view', 'trouver-piece-v3');
      url.searchParams.set('q', query);
      url.searchParams.delete('page');
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
      applyUrl(url);
    });

    const applySmartFilters = (extra = {}) => {
      const url = new URL(window.location.href);
      if (extra && !(extra instanceof Event)) {
        Object.entries(extra).forEach(([cle, valeur]) => { if (valeur) url.searchParams.set(cle, valeur); else url.searchParams.delete(cle); });
      }
      const query = cleanSearchQuery(searchInput?.value || '');
      url.searchParams.set('view', 'trouver-piece-v3');
      if (query) url.searchParams.set('q', query); else url.searchParams.delete('q');
      if (smartSector?.value) url.searchParams.set('sector', smartSector.value); else url.searchParams.delete('sector');
      if (smartBrand?.value) url.searchParams.set('brand', smartBrand.value); else url.searchParams.delete('brand');
      if (smartModel?.value) url.searchParams.set('model', smartModel.value); else url.searchParams.delete('model');
      if (smartCategory?.value) url.searchParams.set('category', smartCategory.value); else url.searchParams.delete('category');
      url.searchParams.delete('sort');
      url.searchParams.delete('page');
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
      applyUrl(url); updateSmartToolbar();
    };

    smartSector?.addEventListener('change', () => {
      const keep = smartCategory?.value || '';
      const items = smartCategoryItems(smartFinderData, smartSector.value);
      fillSmartSelect(smartCategory, items, items.some((item) => item.value === keep) ? keep : '', 'Tous les types');
      applySmartFilters();
    });
    smartBrand?.addEventListener('change', () => { if (smartModel) smartModel.value = ''; refreshSmartModels(''); applySmartFilters(); });
    smartModel?.addEventListener('change', () => {
      const model = smartModel.value ? smartFinderData?.models?.[smartModel.value] : null;
      const selectedModel = smartModel.value;
      if (model?.brand && smartBrand) { smartBrand.value = String(model.brand); refreshSmartModels(selectedModel); }
      applySmartFilters();
    });
    smartCategory?.addEventListener('change', applySmartFilters);

    const clearAllSmartFilters = () => {
      const garderRequete = modeResultats();
      const requete = cleanSearchQuery(new URLSearchParams(window.location.search).get('q') || '');
      if (searchInput && !garderRequete) searchInput.value = '';
      if (smartSector) smartSector.value = '';
      if (smartBrand) smartBrand.value = '';
      if (smartModel) smartModel.value = '';
      if (smartCategory) smartCategory.value = '';
      refreshSmartModels('');

      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('view', 'trouver-piece-v3');
      if (garderRequete && requete) { url.searchParams.set('q', requete); url.searchParams.set('appareil', 'tous'); }
      if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);

      resAppareilAuto = false;
      applyUrl(url);
      updateSmartToolbar();
    };

    smartReset?.addEventListener('click', clearAllSmartFilters);
    smartClearAll?.addEventListener('click', clearAllSmartFilters);

    smartOpenButtons.forEach((button) => button.addEventListener('click', () => openSmartDrawer(button.getAttribute('data-k-filter-open') || 'all')));
    smartCloseButtons.forEach((button) => button.addEventListener('click', closeSmartDrawer));
    smartOverlay?.addEventListener('pointerdown', closeSmartDrawer);
    document.addEventListener('pointerdown', (event) => {
      if (!smartDrawer?.classList.contains('is-open')) return;
      const target = event.target instanceof Element ? event.target : null;
      if (!target || smartDrawer.contains(target) || target.closest('[data-k-filter-open]')) return;
      closeSmartDrawer();
    }, true);
    smartDrawer?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); closeSmartDrawer(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...smartDrawer.querySelectorAll('button:not([disabled]), select:not([disabled]), a[href], input')].filter((item) => !item.hidden && item.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    window.addEventListener('popstate', () => {
      initSmartFilters().finally(() => {
        syncModeResultats();
        applyState(new URLSearchParams(window.location.search).get('q') || '').catch(() => {
          if (modeResultats()) resErreur(); else restoreServerFallback();
        });
      });
    });

    const bootSmartFinder = (attempt = 0) => {
      if (!window.KrepiteSearch?.loadFinderData) {
        if (attempt < 20) {
          window.setTimeout(() => bootSmartFinder(attempt + 1), 50);
        } else if (modeResultats()) {
          resErreur();
        }
        return;
      }
      loadSmartFinderData()
        .then(() => { appliquerAppareilMemorise(); return initSmartFilters(); })
        .then(() => applyUrl(window.location.href, true))
        .catch(() => (modeResultats() ? resErreur() : restoreServerFallback()));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bootSmartFinder(), { once: true });
    } else {
      bootSmartFinder();
    }
  })();
